import { WixApiCall } from "./WixApiCall";
import { Config } from "./config/Config";
import { MenuItemImage } from "./editor/MenuItemImage";
import { GlobalEventBus } from "./events/GlobalEventBus";
import { EventTypes } from "./events/EventTypes";
import { Item, IWixItemsInCollection } from "../../src/wix-api/typedefs/IWixItemsInCollection";

export class CategoryItemsLister extends WixApiCall{
  private currentItemsInCollection: IWixItemsInCollection | undefined;
  constructor(baseUrl:string = Config.API_BASE_URL) {
    super(baseUrl);
  }
  async getItems(categoryId: string): Promise<MenuItemImage[]>{
    GlobalEventBus.dispatchEvent({
      type: EventTypes.LOADING,
      eventData: 'getItems'
    });
    const response = await fetch(`${this.baseUrl}getitemsincollection/${categoryId}`);
    const json: IWixItemsInCollection = await response.json();
    this.currentItemsInCollection = json;
    const output: MenuItemImage[] = [];
    const mainItem: Item = json.items[0];
    if (mainItem) {
      const colors = mainItem.productOptions?.Color?.choices;
      if (colors?.length>0) {
        for (const color of colors) {
          const colorDesc: string = color.description.toLowerCase().replace(/\s/g,'');
          const itemDesc: string = mainItem.name.toLowerCase().replace(/\s/g,'_').replace(/&/g,'');
          const colorUrl = `/assets/color/${colorDesc}.png`;
          const menuItemImage: MenuItemImage = new MenuItemImage(GlobalEventBus, 'item_' + mainItem._id, colorUrl, color? color.value : undefined, color);
          menuItemImage.videoUrl = `/assets/video/${itemDesc}_${colorDesc}.mp4`;
          output.push(menuItemImage);
        }
      } else {
        console.error('No colors found for category', categoryId, 'item', mainItem);
      }
    } else {
      console.error('No items found for category', categoryId);
    }
    GlobalEventBus.dispatchEvent({
      type: EventTypes.LOADED,
      eventData: 'getItems'
    });
    output.push(new MenuItemImage(GlobalEventBus, 'item_rainbow', 'assets/video/tailorgif.gif', 'assets/video/tailorgif.gif', {
     description: '',
     value: '',
     mediaItems: [],
     inStock: true,
     mainMedia: 'rainbow.png',
     visible: true,
    }));
    return output;
  }
  getItemById(id: string): Item | undefined {
    if (this.currentItemsInCollection){
      const item: Item | undefined = this.currentItemsInCollection.items.find((value, index) => {
        return value._id === id;
      });
      return item;
    }
    return undefined;
  }
}
